import React, { Component } from "react";
import axios from "axios";
import PanelHeader from "../../components/PanelHeader/PanelHeader";
import { Card, CardBody, Col, CardHeader, Row } from "reactstrap";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  withGoogleMap,
  Polyline,
  withScriptjs,
  KmlLayer, Polygon
} from "react-google-maps";
import { Button, Tag, Space, DatePicker, Collapse } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import blueMarker from "../../assets/img/mapMarker/blue_map_marker.png";
import redMarker from "../../assets/img/mapMarker/red_map_marker.png";
import yellowMarker from "../../assets/img/mapMarker/yellow_map_marker.png";
import greenMarker from "../../assets/img/mapMarker/green_map_marker.png";
import carMarker from "../../assets/img/mapMarker/car-pin.png";
import ctosMarker from "../../assets/img/mapMarker/Caja-nadunet.png"
import dayjs from "dayjs";
import { VisitCard } from "./components/VisitCard";
import { CarCard } from "./components/CarCard";
import { VisitMarker } from "./components/VisitMarker";
import { CarMarker } from "./components/CarMarker";
import { Kmz } from "./components/Kmz";
import { InfoCard } from "./components/InfoCard";
class MyMapComponent extends Component {
  render() {
    return (
      <GoogleMap
        defaultZoom={12}
        defaultCenter={{ lat: 39.59242621528501, lng: -0.45891777479907003 }}
        mapTypeId={"satellite"}
        options={{
          disableDefaultUI: true,
          zoomControl: false,
          streetViewControl: false,
          mapTypeControl: true,
          fullscreenControl: false,
          gestureHandling: "greedy",
          styles: [
            {
              featureType: "poi",
              elementType: "labels",
              stylers: [{ visibility: "off" }],
            },
            {
              featureType: "road",
              elementType: "labels",
              stylers: [{ visibility: "off" }],
            },
          ],
        }}
      >
        {this.props.kmlUrl && (
          <KmlLayer
            url={this.props.kmlUrl}
            options={{ preserveViewport: true }}
          />
        )}
        {this.props.polylines.map((polyline, index) => (
          <Polyline
            key={index}
            path={polyline.path}
            options={{
              strokeColor: polyline.strokeColor,
              strokeOpacity: polyline.strokeOpacity,
              strokeWeight: polyline.strokeWeight,
            }}
          />
        ))}
        {this.props.polygons.map((polygon, index) => (
          <Polygon
            key={index}
            path={polygon.path}
            options={{
              fillColor: polygon.fillColor,
              fillOpacity: polygon.fillOpacity,
              strokeColor: polygon.strokeColor,
              strokeOpacity: polygon.strokeOpacity,
              strokeWeight: polygon.strokeWeight,
            }}
          />
        ))}

        {this.props.markers.map((marker, index) => (
          <Marker
            key={index}
            position={{ lat: marker.lat, lng: marker.lng }}
            onClick={() => this.props.handleOpenMarker(index)}
            icon={{
              url: marker.statusIcon,
              scaledSize: new window.google.maps.Size(40, 40),
            }}
          >
            {marker.showInfo &&
              (marker.isCar ? (
                <CarMarker
                  marker={marker}
                  index={index}
                  handleOpenMarker={this.props.handleOpenMarker}
                />
              ) : marker.isKmz ? (
                <InfoCard
                  marker={marker}
                  index={index}
                  handleOpenMarker={this.props.handleOpenMarker}
                />
              ) : (
                <VisitMarker
                  marker={marker}
                  index={index}
                  handleOpenMarker={this.props.handleOpenMarker}
                />
              ))}
          </Marker>
        ))}
      </GoogleMap>
    );
  }
}
const WrappedMapComponent = withScriptjs(withGoogleMap(MyMapComponent));

class MapView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      loading: false,
      visitsList: [],
      carsList: [],
      interval: 0,
      kmzMarkersList: [],
      polylinesList: [],
      polygonsList: [],
      preferenceOptions: [],
      preferences: ['CTOs'],
      filteredPolylines: [],
      filteredMarkers: [],
      filteredPolygons: [],
      activePreferences: true,
    };
    this.handleRedirect = this.handleRedirect.bind(this);
    this.handleOpenMarker = this.handleOpenMarker.bind(this);
    // this.handleKmzUpload = this.handleKmzUpload.bind(this);
    this.handlePreferenceChange = this.handlePreferenceChange.bind(this);
    this.base64ToArrayBuffer = this.base64ToArrayBuffer.bind(this);

  }
  async componentDidMount() {
    this.setState({ loading: true });
    const startDate = dayjs();
    const endDate = dayjs();
    await this.handleGetVisits(startDate, endDate);
    await this.handleGetCarsLocations();
    await this.handleGetKmz();
    this.setState(
      {
        startDate: startDate,
        endDate: endDate,
      },
      () => this.setState({ loading: false })
    );
    setInterval(() => this.handleGetCarsLocations(), 30000);
  }
  componentDidUpdate() {
    const isMobile = window.innerWidth <= 990;
    if (this.state.isMobile !== isMobile) {
      this.setState({
        ...this.state,
        isMobile,
      });
    }
  }
  async handleGetKmz() {
    try {
      const result = await axios.post(
        `https://files.nadu.xyz/api/file-download`,
        {
          "file_uuid": "69817a73-a30e-4e4d-8e69-801dd244cedf"
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_NADUFILE}`
          }
        }
      );
      if (result.data && result.data.data) {
        const base64String = result.data.data.replace(/^data:application\/octet-stream;base64,/, '').trim();
        const arrayBuffer = this.base64ToArrayBuffer(base64String);
        this.parseKmz(arrayBuffer);
      }
    } catch (error) {
      console.error("No se ha podido cargar el kmz: ", error);
    }
  }

  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }

  async handleGetVisits(startDate, endDate) {
    try {
      this.setState({ loading: true });
      const startDay = dayjs(startDate).format("YYYY-MM-DD");
      const endDay = dayjs(endDate).format("YYYY-MM-DD");
      const result = await axios.get(
        `https://oficina.nadunet.es/api/rest/get-lista-visitas-domicilio?args[0]=${startDay}--${endDay}`
      );

      const allVisits = result.data.map((visit) => {
        let statusColor = "default";
        let statusIcon = blueMarker;
        switch (parseInt(visit.visit_status.tid)) {
          case 249:
            statusColor = "success";
            statusIcon = greenMarker;
            break;
          case 248:
            statusColor = "processing";
            statusIcon = blueMarker;
            break;
          case 247:
            statusColor = "warning";
            statusIcon = yellowMarker;
            break;
          case 250:
            statusColor = "error";
            statusIcon = redMarker;
            break;
          default:
            break;
        }
        let finishColor = "default";
        switch (parseInt(visit.finish_reason.tid)) {
          case 257:
            finishColor = "success";
            break;
          case 261:
            finishColor = "processing";
            break;
          case 260:
            finishColor = "warning";
            break;
          case 259:
            finishColor = "warning";
            break;
          case 258:
            finishColor = "error";
            break;
          default:
            break;
        }

        return {
          id: visit.id,
          title: visit.title,
          visit_type: visit.visit_type_name,
          visit_status: {
            statusColor: statusColor,
            name: visit.visit_status_name,
          },
          finish_reason: !Array.isArray(visit.finish_reason)
            ? {
              finishColor: finishColor,
              name: visit.finish_reason_name,
            }
            : null,
          visit_address: visit.visit_address,
          visit_locality: visit.visit_locality,
          visit_date_day: visit.visit_date_day,
          visit_date_hour: visit.visit_date_hour,
          technician: [
            ...JSON.parse(visit.assigned_technician),
            ...JSON.parse(visit.working_technician),
          ],
          lat: parseFloat(visit.lat),
          lng: parseFloat(visit.lng),
          statusIcon: statusIcon,
          showInfo: false,
        };
      });
      this.setState({ visitsList: allVisits }, () =>
        this.setState({ loading: false })
      );
    } catch (error) {
      console.error(error);
    }
  }
  async handleGetCarsLocations() {
    try {
      const { data: cars } = await axios.get(
        "https://backoffice.nadu.xyz/api/van-locations"
      );
      if (cars.ok) {
        const formattedData = cars.data.map((car) => ({
          ...car,
          lat: parseFloat(car.location.latitude),
          lng: parseFloat(car.location.longitude),
          statusIcon: carMarker,
          showInfo: false,
          isCar: true,
        }));
        this.setState({ carsList: formattedData });
      }
    } catch (error) {
      console.error(error);
    }
  }
  handleOpenMarker = (index) => {
    const { visitsList, carsList, kmzMarkersList } = this.state;
    const fullArray = [...visitsList, ...carsList, ...kmzMarkersList];

    const updatedFullArray = fullArray.map((visit, i) => {
      if (i === index) {
        return { ...visit, showInfo: true };
      } else {
        return { ...visit, showInfo: false };
      }
    });

    const updatedVisitsList = updatedFullArray.filter((elem) => !elem.isCar && !elem.isKmz);
    const updatedCarsList = updatedFullArray.filter((elem) => elem.isCar && !elem.isKmz);
    const updatedKmzList = updatedFullArray.filter((elem) => elem.isKmz);
    this.setState({ visitsList: updatedVisitsList, carsList: updatedCarsList, kmzMarkersList: updatedKmzList });
  };
  handleRedirect(idx) {
    this.props.history.push(`/citas/${idx}`);
  }
  // handleKmzUpload = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       const arrayBuffer = e.target.result;
  //       this.parseKmz(arrayBuffer);
  //     };
  //     reader.readAsArrayBuffer(file);
  //   }
  // };
  // convertToBase64 = (file) => {
  //   if (!file) {
  //     alert("Selecciona un archivo primero");
  //     return;
  //   }
  //   const reader = new FileReader();
  //   reader.onload = function (event) {
  //     const dataUrl = event.target.result;
  //     console.log("Data URL:", dataUrl);

  //     const base64String = dataUrl.split(',')[1];
  //     console.log("Base64 String:", base64String);

  //     document.getElementById('output').textContent = base64String;
  //   };
  //   reader.onerror = function (error) {
  //     console.error("Error leyendo el archivo: ", error);
  //   };

  //   reader.readAsDataURL(file);
  // }
  parseKmz = (arrayBuffer) => {
    const JSZip = require('jszip');
    const xml2js = require('xml2js');
    JSZip.loadAsync(arrayBuffer).then((zip) => {
      zip.file('doc.kml').async('text').then((kmlText) => {
        const parser = new xml2js.Parser();
        parser.parseString(kmlText, (err, result) => {
          if (err) {
            console.error('Error al parsear KML:', err);
            return;
          }
          const markers = [];
          const polylines = [];
          const polygons = [];
          const options = [];
          for (let index = 0; index < result.kml.Document[0].Folder.length; index++) {
            let parentName = result.kml.Document[0].Folder[index].name[0];
            options.push({ value: parentName, label: parentName });
            this.traverseKML(result.kml.Document[0].Folder[index], markers, polylines, polygons, parentName);
          }
          this.setState({ preferenceOptions: options });
          if (!this.areMarkersEqual(this.state.kmzMarkersList, markers)) {
            const filteredMarkers = markers.filter(marker => this.state.preferences.includes(marker.parentName));
            const filteredPolylines = polylines.filter(polyline => this.state.preferences.includes(polyline.parentName));
            const filteredPolygons = polygons.filter(polygon => this.state.preferences.includes(polygon.parentName));
            this.setState({ kmzMarkersList: filteredMarkers });
            this.setState({ polylinesList: filteredPolylines });
            this.setState({ polygonsList: filteredPolygons });
          }
        });
      });
    });
  };
  traverseKML = (document, markers, polylines, polygons, parentName) => {
    if (document.Folder) {
      document.Folder.forEach((folder) => {
        this.traverseKML(folder, markers, polylines, polygons, parentName);
      });
    }
    let polylineCoords = [];
    let polygonCoords = [];
    if (document.Placemark) {
      document.Placemark.forEach((placemark) => {
        if (placemark.Point && placemark.Point[0].coordinates) {
          const coords = placemark.Point[0].coordinates[0].split(',');
          const lng = parseFloat(coords[0]);
          const lat = parseFloat(coords[1]);
          if (!isNaN(lat) && !isNaN(lng)) {
            let statusIcon = blueMarker;
            switch (parentName) {
              case "Cable troncal":
                statusIcon = yellowMarker;
                break;
              case "Cable distribucion":
                statusIcon = greenMarker;
                break;
              case "Red por construir":
                statusIcon = redMarker;
                break;
              case 'CTOs':
                statusIcon = ctosMarker;
                break;
              case 'GIS':
                statusIcon = blueMarker;
                break;
              case "Telefonica":
                statusIcon = greenMarker;
                break;
              case "Obras propias":
              case "Clusters y cajas de empalme":
                statusIcon = greenMarker;
                break;
              default:
                statusIcon = blueMarker;
                break;
            }
            markers.push({
              lat,
              lng,
              name: placemark.name,
              parentName: parentName,
              description: placemark.description,
              statusIcon,
              isKmz: true,
              showInfo: false
            });
          }
        } else if (placemark.LineString && placemark.LineString[0].coordinates) {
          placemark.LineString[0].coordinates.forEach(coord => {
            const coordParts = coord.split(',');
            const lng = parseFloat(coordParts[0]);
            const lat = parseFloat(coordParts[1]);
            if (!isNaN(lat) && !isNaN(lng)) {
              polylineCoords.push({ lat, lng });
            }
          });
        } else if (placemark.Polygon && placemark.Polygon[0].outerBoundaryIs && placemark.Polygon[0].outerBoundaryIs[0].LinearRing) {
          const coordinates = placemark.Polygon[0].outerBoundaryIs[0].LinearRing[0].coordinates;
          coordinates.forEach(coord => {
            const coordParts = coord.split(',');
            const lng = parseFloat(coordParts[0]);
            const lat = parseFloat(coordParts[1]);
            if (!isNaN(lat) && !isNaN(lng)) {
              polygonCoords.push({ lat, lng });
            }
          });
        }
      });
      if (polylineCoords.length > 0) {
        polylines.push({
          path: polylineCoords,
          strokeColor: '#00FF00',
          strokeOpacity: 1.0,
          strokeWeight: 2,
          parentName: parentName
        });
        polylineCoords = [];
      }
      if (polygonCoords.length > 0) {
        polygons.push({
          path: polygonCoords,
          fillColor: '#808080',
          fillOpacity: 0.35,
          strokeColor: '#808080',
          strokeOpacity: 1.0,
          strokeWeight: 2,
          parentName: parentName
        });
        polygonCoords = [];
      }
    }
  };

  areMarkersEqual = (prevMarkers, newMarkers) => {
    if (prevMarkers.length !== newMarkers.length) {
      return false;
    }

    for (let i = 0; i < prevMarkers.length; i++) {
      const prevMarker = prevMarkers[i];
      const newMarker = newMarkers[i];

      if (
        prevMarker.lat !== newMarker.lat ||
        prevMarker.lng !== newMarker.lng ||
        prevMarker.name !== newMarker.name ||
        prevMarker.style !== newMarker.style
      ) {
        return false;
      }
    }

    return true;
  };

  // handleApplyPreferences = () => {
  //   const { preferences, activePreferences, kmzMarkersList, polylinesList, polygonsList } = this.state;
  //   console.log("activePreferences", activePreferences)
  //   console.log("preferences", preferences)
  //   if (activePreferences) {
  //     const filteredMarkers = kmzMarkersList.filter(marker => preferences.includes(marker.parentName));
  //     const filteredPolylines = polylinesList.filter(polyline => preferences.includes(polyline.parentName));
  //     const filteredPolygons = polygonsList.filter(polygon => preferences.includes(polygon.parentName));
  //     this.setState({ filteredPolylines: filteredPolylines });
  //     this.setState({ filteredMarkers: filteredMarkers });
  //     this.setState({ filteredPolygons: filteredPolygons });
  //   } else {
  //     this.setState({ filteredPreferences: [] });
  //   }
  //   this.setState({ activePreferences: !activePreferences });
  // };
  handlePreferenceChange = (checkedValues) => {
    this.setState({ preferences: checkedValues });
  };
  render() {
    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          <Row>
            <Col xs={12}>
              <Card>
                <CardHeader
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>Mapa de Citas</h5>
                  <Space>
                    {this.state.startDate && this.state.endDate && (
                      <DatePicker.RangePicker
                        defaultValue={[
                          this.state.startDate,
                          this.state.endDate,
                        ]}
                        format={"DD/MM/YYYY"}
                        onChange={(props) => {
                          const [startDate, endDate] = props;
                          this.handleGetVisits(startDate, endDate);
                        }}
                        allowClear={false}
                      />
                    )}
                  </Space>
                </CardHeader>
                <CardBody>
                  {this.state.loading ? (
                    <Space
                      style={{
                        minHeight: "70vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <LoadingOutlined style={{ fontSize: "28px" }} />
                    </Space>
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: this.state.isMobile ? "column" : "row",
                        gap: "10px",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <WrappedMapComponent
                          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBqHety4jjWm2r747ZT8L-pUDDQqCLY05o&v=3.exp&libraries=geometry,drawing,places"
                          loadingElement={<div style={{ height: `100%` }} />}
                          containerElement={<div style={{ height: `560px` }} />}
                          mapElement={<div style={{ height: `100%` }} />}
                          markers={[...this.state.visitsList,
                          ...this.state.carsList,
                          ...this.state.kmzMarkersList]}
                          polylines={this.state.polylinesList}
                          polygons={this.state.polygonsList}
                          handleOpenMarker={this.handleOpenMarker}
                          handleRedirect={this.handleRedirect}
                        />
                      </div>
                      <div
                        style={{
                          width: "30%",
                          height: "560px", //"100%",
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                          alignItems: "flex-start",
                          overflow: "scroll",
                        }}
                      >
                        <Collapse
                          accordion={true}
                          defaultActiveKey={["1"]}
                          style={{ width: "100%" }}
                          items={[
                            {
                              key: "1",
                              label: "Instalaciones",
                              children: (
                                <VisitCard
                                  visitsList={this.state.visitsList}
                                  handleOpenMarker={this.handleOpenMarker}
                                />
                              ),
                            },
                            {
                              key: "2",
                              label: "Furgonetas",
                              children: (
                                <CarCard
                                  visitLength={this.state.visitsList.length}
                                  carsList={this.state.carsList}
                                  handleOpenMarker={this.handleOpenMarker}
                                />
                              ),
                            },
                            {
                              key: "3",
                              label: "Kmz",
                              children: (
                                <Kmz
                                  preferences={this.state.preferences}
                                  preferenceOptions={this.preferenceOptions}
                                  activePreferences={this.activePreferences}
                                  // handleKmzUpload={this.handleKmzUpload}
                                  handlePreferenceChange={this.handlePreferenceChange}
                                />
                              ),
                            },
                          ]}
                        />
                      </div>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default MapView;



// WEBPACK FOOTER //
// ./src/views/HomeVisits/MapView.jsx